import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

// childAnswers should be sent only if answer is present
// if false they just saved in redux store for prefill additional questions form
const convertAdditionalInfoDataToRequestPayload = additionalInfoFormData => {
  if (isEmpty(additionalInfoFormData)) {
    return additionalInfoFormData;
  }

  const childQuestions = get(
    additionalInfoFormData,
    'questionAnswers.childQuestions',
    [],
  );

  const childAnswers = get(
    additionalInfoFormData,
    'questionAnswers.childAnswers',
    [],
  );

  const answer = get(additionalInfoFormData, 'questionAnswers.answer');

  const question = get(additionalInfoFormData, 'questionAnswers.question');

  const result =
    [childQuestions, childAnswers].find(arr => arr.length > 0) || [];

  return {
    questionAnswers: {
      answer,
      question,
      ...(answer ? { childAnswers: result } : {}),
    },
  };
};

export default convertAdditionalInfoDataToRequestPayload;



// WEBPACK FOOTER //
// ./src/utils/appointments/convert-additional-info-data-to-request-payload.js